const PAP_SCRIPT_ID = "pap_x2s6df8d";
const PAP_SCRIPT_SRC = "https://haptic.postaffiliatepro.com/scripts/4yoouknj1l";
const PAP_ACCOUNT_ID = "default1";

let scriptLoadPromise = null;

const waitForPostAffTracker = () =>
  new Promise((resolve) => {
    const check = () => {
      if (window.PostAffTracker) {
        resolve();
        return;
      }
      setTimeout(check, 50);
    };
    check();
  });

export const loadPostAffScript = () => {
  if (typeof window === "undefined") {
    return Promise.resolve();
  }

  if (window.PostAffTracker) {
    return Promise.resolve();
  }

  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }

  scriptLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(PAP_SCRIPT_ID);

    if (existingScript) {
      existingScript.addEventListener("load", () => waitForPostAffTracker().then(resolve));
      existingScript.addEventListener("error", () =>
        reject(new Error("Failed to load PostAffiliatePro script"))
      );
      waitForPostAffTracker().then(resolve);
      return;
    }

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = PAP_SCRIPT_ID;
    script.src = PAP_SCRIPT_SRC;
    script.onload = () => waitForPostAffTracker().then(resolve);
    script.onerror = () => reject(new Error("Failed to load PostAffiliatePro script"));
    document.head.appendChild(script);
  });

  return scriptLoadPromise;
};

export const trackPostAffClick = async () => {
  try {
    await loadPostAffScript();
    if (window.PostAffTracker) {
      window.PostAffTracker.setAccountId(PAP_ACCOUNT_ID);
      window.PostAffTracker.track();
    }
  } catch (err) {
    console.error("PostAffiliatePro click tracking error:", err);
  }
};

export const registerPostAffSale = async ({ totalCost, orderId, productId }) => {
  if (!totalCost || !orderId) {
    return;
  }

  try {
    await loadPostAffScript();
    if (window.PostAffTracker) {
      window.PostAffTracker.setAccountId(PAP_ACCOUNT_ID);
      const sale = window.PostAffTracker.createSale();
      sale.setTotalCost(String(totalCost));
      sale.setOrderID(String(orderId));
      if (productId) {
        sale.setProductID(String(productId));
      }
      window.PostAffTracker.register();
    }
  } catch (err) {
    console.error("PostAffiliatePro sale registration error:", err);
  }
};
